import ReactDOM from 'react-dom'

import { Page } from './ui/Page'
import { Table } from './ui/Table'
import { Form } from './ui/Form'
import { Layout } from './ui/Layout'
import { Alert } from './ui/Alert'
import { Loading } from './ui/Loading'
import { Button } from './ui/Button'
import { Modal } from './ui/Modal'
import { Checkbox } from './ui/Checkbox'
import { Tabs } from './ui/Tabs'
import { Panel } from './ui/Panel'
const ui = {
    Page,
    Table,
    Form,
    Layout,
    Alert,
    Loading,
    Button,
    Modal,
    Checkbox,
    Tabs,
    Panel
}
const Renderer = ReactDOM
export {
    ui,
    Renderer
}